
import styled from "styled-components"
import PageTopTitle from "../../components/shared/PageTopTitle"
import InputText from "../../components/shared/input/new/InputText"
import { useState } from "react"
import InputNumber from "../../components/shared/input/new/InputNumber"
import InputSelect from "../../components/shared/input/new/InputSelect"
import { useEffect } from "react"
import formatConverter from "../../helper/formatConverter"
import useWindowDimensions from "../../hooks/useWindowSize"

const Container = styled.div`

    width: 100%;

    .wrapper{
        display: flex;
        flex-direction: column;
        width: 100%;

        .content{
            gap: 60px;
            margin: 30px;
            padding-top: 30px;
            display: flex;
            flex-direction: column;
            align-items: center;

            .top-container{
                display: flex;
                align-items: center;
                gap: 20px;

                .kdv-select{
                    width: 250px;
                    height: 40px;
                    border-radius: 10px;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    border: 2px solid var(--color-main);
                    overflow: hidden;

                    .btn{
                        width: 50%;
                        height: 100%;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        font-size: var(--font-size-sm);
                        font-weight: var(--font-weight-lg);
                    }

                    .passive-btn{
                        /* background-color: ${({theme}) => theme.secondaryBgColor}; */
                    }

                    .active-btn{
                        background-color: var(--color-main);
                        color: #fff;
                    }
                }
                
            }

            .mid-content-container{
                display: flex;
                flex-direction: column;

                .content-item{
                    display: flex;
                    align-items: center;
                    width: 650px;
                    border: 1px solid ${({theme}) => theme.mainTextColor};
                    border-top: none;

                    &:first-child{
                        border-top: 1px solid ${({theme}) => theme.mainTextColor};
                    }

                    .key{
                        font-size: var(--font-size-sm);
                        font-weight: var(--font-weight-lg);
                        width: 50%;
                        padding: 10px 15px;
                    }

                    .value{
                        font-size: var(--font-size-sm);
                        font-weight: var(--font-weight-md);
                        width: 50%;
                        padding: 10px 15px;
                        border-left: 1px solid ${({theme}) => theme.mainTextColor};
                   
                    }
                }
            }

            .tevkifat-container{
                display: flex;
                gap: 30px;
            }

            .tevkifat-result-container{
                display: flex;
                flex-direction: column;
                align-items: center;
                gap: 20px;

                h3{
                    font-size: var(--font-size-md);
                    font-weight: var(--font-weight-md);
                }

                .bottom-content-container{
                    display: flex;
                    flex-direction: column;

                    .content-item{
                        display: flex;
                        align-items: center;
                        width: 650px;
                        border: 1px solid ${({theme}) => theme.mainTextColor};
                        border-top: none;

                        &:nth-child(1){
                            border-top: 1px solid ${({theme}) => theme.mainTextColor};
                        }

                        .key{
                            font-size: var(--font-size-sm);
                            font-weight: var(--font-weight-lg);
                            width: 50%;
                            padding: 10px 15px;
                        }

                        .value{
                            font-size: var(--font-size-sm);
                            font-weight: var(--font-weight-md);
                            width: 50%;
                            padding: 10px 15px;
                            border-left: 1px solid ${({theme}) => theme.mainTextColor};
                        }
                    }
                }
            }


            .desc{
                font-size: var(--font-size-sm);
                font-weight: var(--font-weight-md);
            }
            
        }

    }

    @media (max-width: 750px) {
      border: none;
      width: 100%;


      .content-item{
        width: 510px !important;
      }
  }

  @media (max-width: 550px) {

      .top-container, .tevkifat-container{
        flex-direction: column;
      }

      .content-item{
        width: 360px !important;
      }

    .kdv-select{
        width: 380px !important;
    }

    margin-bottom: 40px;
  }
`
const options = [
    {
        id: 1,
        text: "Nakliye Hizmeti",
        oran: 20
    },
    {
        id: 2,
        text: "Araç Kiralama",
        oran: 0
    },
    {
        id: 3,
        text: "Komisyon",
        oran: 0
    },
    {
        id: 4,
        text: "Diğer"
    },
]

const KDVveTevkifatHesaplama = () => {

    const [activeKdvType, setActiveKdvType] = useState(2)
    const kdvData = 20
    const {windowDimensions} = useWindowDimensions()

    const [kdvHaric, setKdvHaric] = useState("")
    const [kdvTutar, setKdvTutar] = useState("")
    const [kdvDahil, setKdvDahil] = useState("")

    const [amount, setAmount] = useState("")

    const [malHizmetType, setMalHizmetType] = useState({
        id: 1,
        text: "Nakliye Hizmeti",
        oran: 20
    })

    const [tevkifatData, setTevkifatData] = useState(20)
    
    const [hesaplananKDVTevkifat, setHesaplananKDVTevkifat] = useState("")
    const [beyanEdilecekKdv, setBeyanEdilecekKdv] = useState("")
    const [odenecekTutar, setOdenecekTutar] = useState("")

    useEffect(() => {
        if(malHizmetType.id === 4){
            setTevkifatData("")
        }
        else{
            setTevkifatData(malHizmetType.oran)
        }

    },[malHizmetType.id, malHizmetType.oran])



    useEffect(() => {
        const amt = amount.replace(/[^0-9]/g, '')
        if(amt && !tevkifatData){
            const kdvHrc = activeKdvType === 2 ? parseFloat(amt) / (100+kdvData) * 100 : parseFloat(amt) 
            setKdvHaric(kdvHrc)
            
            const kdvTtr = kdvHrc / 100 * kdvData
            setKdvTutar(parseFloat(kdvTtr))
            
            const kdvDhl = kdvHrc + kdvTtr
            setKdvDahil(kdvDhl)

            setHesaplananKDVTevkifat("")
            setBeyanEdilecekKdv("")
            setOdenecekTutar("")
        }

        else if(amt && tevkifatData){
            const kdvHrc = activeKdvType === 2 ? parseFloat(amt) / (100+kdvData) * 100 : parseFloat(amt)   
            setKdvHaric(kdvHrc)

            const kdvTtr = kdvHrc / 100 * kdvData
            setKdvTutar(parseFloat(kdvTtr))

            const kdvDhl =  kdvHrc + kdvTtr
            setKdvDahil(kdvDhl)

            const hesaplananKdv = parseFloat(kdvTtr) / 100 * parseFloat(tevkifatData)
            setHesaplananKDVTevkifat(hesaplananKdv)

            const beyanEdlckKdv = parseFloat(kdvTtr) - hesaplananKdv
            setBeyanEdilecekKdv(beyanEdlckKdv)

            const odenecekTtr = kdvHrc + beyanEdlckKdv
            setOdenecekTutar(odenecekTtr)
        }

        else{
            setKdvHaric("")
            setKdvTutar("")
            setKdvDahil("")

            setHesaplananKDVTevkifat("")
            setBeyanEdilecekKdv("")
            setOdenecekTutar("")
        }

    },[amount, tevkifatData, activeKdvType, malHizmetType.oran])



  return (
    <Container>
    <div className="wrapper">
        <PageTopTitle title={"KDV ve Tevkifat Hesaplama"} position="sticky"/>
            <div className="content">
                <div className="top-container">
                    {/* <InputText data={amount} setData={(e) =>setAmount(parseFloat(e.target.value.replace(/[^0-9]/g, '')))} labelText="Tutar" inputWidth={"380px"} /> */}
                    <InputNumber data={amount} setData={setAmount} labelText="Tutar" inputWidth={windowDimensions.width > 750 ? "380px" :(windowDimensions.width <= 750 && windowDimensions.width> 550)  ? "240px" : "380px"} suffix=" TL" />

                    <div className="kdv-select">
                        <button onClick={() => setActiveKdvType(1)} className={activeKdvType === 1 ? "active-btn btn" : "passive-btn btn"}>KDV Hariç</button>
                        <button onClick={() => setActiveKdvType(2)} className={activeKdvType === 2 ? "active-btn btn" : "passive-btn btn"}>KDV Dahil</button>
                    </div>
                </div>

                <div className="mid-content-container">
                    <div className="content-item">
                        <div className="key">KDV Hariç Tutar:</div>
                        <div className="value">{`${formatConverter(kdvHaric, 0)} TL`}</div>
                    </div>
                    <div className="content-item">
                        <div className="key">KDV Tutarı:</div>
                        <div className="value">{`${formatConverter(kdvTutar, 0)} TL`}</div>

                    </div>
                    <div className="content-item">
                        <div className="key">KDV Dahil Tutar:</div>
                        <div className="value">{`${formatConverter(kdvDahil, 0)} TL`}</div>
                    </div>
                </div>

                <div className="tevkifat-container">
                    <InputSelect data={malHizmetType?.text} setData={setMalHizmetType} labelText={"Mal Hizmet"} inputWidth={windowDimensions.width > 750 ? "310px" :(windowDimensions.width <= 750 && windowDimensions.width> 550)  ? "240px" : "380px"}  initialOptions={options} name={"malHizmetType"}/>
                    {
                        (malHizmetType.id === 4 || malHizmetType.id === 1) &&
                        <InputText data={tevkifatData} setData={(e) => malHizmetType.id === 4 && setTevkifatData(e.target.value.replace(/[^0-9]/g, ''))} labelText="Tevkifat Oranı %" inputWidth={windowDimensions.width > 750 ? "310px" :(windowDimensions.width <= 750 && windowDimensions.width> 550)  ? "240px" : "380px"} />
                    }
                </div>

                {
                    parseFloat(kdvDahil) < 2000 && <p className="desc">2000 TL den küçük olduğu için Tevkifat Faturası kesilmemelidir.</p>
                }

                {
                    (parseFloat(kdvDahil) >= 2000 && (malHizmetType.id !== 2 && malHizmetType.id !== 3) && ((malHizmetType.id === 4 && tevkifatData) || malHizmetType.id === 1)) &&
                    <div className="tevkifat-result-container">
                        <h3>Tevkifatlı Fatura Bilgileri</h3>
                        <div className="bottom-content-container">
                            <div className="content-item">
                                <div className="key">Mal Hizmet Toplam Tutarı (KDV Hariç):</div>
                                <div className="value">{`${formatConverter(kdvHaric, 0)} TL`}</div>
                            </div>
                            <div className="content-item">
                                <div className="key">Hesaplanan KDV (%{kdvData}):</div>
                                <div className="value">{`${formatConverter(kdvTutar, 0)} TL`}</div>
                            </div>
                            <div className="content-item">
                                <div className="key">Vergiler Dahil Toplam Tutar:</div>
                                <div className="value">{`${formatConverter(kdvDahil, 0)} TL`}</div>
                            </div>
                            <div className="content-item">
                                <div className="key">Hesaplanan KDV Tevkifat (%{tevkifatData}):</div>
                                <div className="value">{`${formatConverter(hesaplananKDVTevkifat, 0)} TL`}</div>
                            </div>
                            <div className="content-item">
                                <div className="key">Beyan Edilen KDV:</div>
                                <div className="value">{`${formatConverter(beyanEdilecekKdv, 0)} TL`}</div>
                            </div>
                            <div className="content-item">
                                <div className="key">Ödenecek Tutar:</div>
                                <div className="value">{`${formatConverter(odenecekTutar, 0)} TL`}</div>
                            </div>
                        </div>
                    </div>
                }

                {
                    (parseFloat(kdvDahil) >= 2000 && (malHizmetType.id === 2 || malHizmetType.id === 3)) &&
                    <p className="desc">Araç Kiralamada ve komisyonda tevkifat yoktur, tevkifatlı fatura kesilmemektedir.</p>
                }

                {
                    (parseFloat(kdvDahil) >= 2000 && malHizmetType.id === 4 && !tevkifatData) &&
                    <p className="desc">Lütfen tevkifat oranını giriniz.</p>
                }

                {
                    (parseFloat(kdvDahil) < 2000) &&
                    <p className="desc">2000 TL altında tevkifatlı fatura kesilmemektedir.</p>
                }

                {/* <div className="mid-input-side">
                    <InputNumber data={kdvHaric} setData={setKdvHaric} inputWidth={"400px"} labelText={"KDV Hariç Tutar"} name={"kdvHaric"} suffix="TL" />
                    <InputNumber data={kdvTutar} setData={setKdvTutar} inputWidth={"400px"} labelText={"KDV Tutarı"} name={"kdvTutar"} suffix="TL"/>
                    <InputNumber data={kdvDahil} setData={setKdvDahil} inputWidth={"400px"} labelText={"KDV Hariç Tutar"} name={"kdvDahil"} suffix="TL"/>
                </div> */}
            </div>
        </div>
    </Container>
  )
}

export default KDVveTevkifatHesaplama